import ga from "@starter/Framework/Common/GoogleAnalytics";
import { TrackQuoteRejectedParameters } from "@starter/Framework/Common/GoogleAnalytics/trackers/quote/trackQuoteRejected";
import { PartialSpecific } from "@toolkit/Framework/Types/Common";

const useTrackQuoteRejected = (
    parameters: PartialSpecific<TrackQuoteRejectedParameters, "items"> = {},
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    const hookParameters: TrackQuoteRejectedParameters = {
        ...ga.use.eventListParameters(options),
        ...parameters,
    };

    const hookOptions: Toolkit.GoogleAnalytics.Options = {
        quote: ga.use.quote(options),
        ...options,
    };

    return (parameters: Partial<TrackQuoteRejectedParameters> = {}, options?: Toolkit.GoogleAnalytics.Options) => {
        return ga.track.quoteRejected({ ...hookParameters, ...parameters }, { ...hookOptions, ...options });
    };
};

export default useTrackQuoteRejected;
